{
  "info": "Informazioni",
  "negative": "Errore",
  "notice": "Avviso",
  "positive": "Operazione riuscita"
}
